import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PaziaInput } from "components/atoms";
import { adminAuthApi } from "api";
import { AuthActionTypes, AuthContext } from "store/auth/AuthContext";
import { useToaster } from "utils";
import { routes } from "consts";
import { PaziaFormButton } from "components/atoms";

export const LoginForm = () => {
  const { dispatch, state } = useContext(AuthContext);
  const navigate = useNavigate();
  const { showError } = useToaster();
  const methods = useForm<AdminLoginFormData>({
    resolver: yupResolver(schema),
  });

  const { handleSubmit } = methods;
  const onSubmit = async (formData: AdminLoginFormData) => {
    try {
      const {
        data: { user, token },
      } = await adminAuthApi.login(formData);
      dispatch({
        type: AuthActionTypes.SetUser,
        payload: user,
      });
      localStorage.setItem("api_token", token);
      navigate(routes.DASHBOARD);
    } catch (error) {
      showError("Niepoprawne dane logowania");
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <PaziaInput name={FORM_NAMES.EMAIL} label="Email" required />
        <PaziaInput name={FORM_NAMES.PASSWORD} label="Hasło" type="password" required />

        <div className="mt-6 flex items-center justify-between">
          <div className="mr-1">
            {/* <Link className="text-sm underline hover:no-underline" to="/reset-password">
              Zapomniałeś hasła?
            </Link> */}
          </div>
          <PaziaFormButton type="primary" title="Zaloguj" />
        </div>
      </form>
    </FormProvider>
  );
};

const FORM_NAMES = {
  EMAIL: "email",
  PASSWORD: "password",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.EMAIL]: yup.string().required(),
    [FORM_NAMES.PASSWORD]: yup.string().required(),
  })
  .required();

export type AdminLoginFormData = yup.InferType<typeof schema>;
